// extracted by mini-css-extract-plugin
export default {"setPasswordBox":"_ForgotPassword_setPasswordBox__5hrSP"};